import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

const portalRoot = () => document.getElementById('portal-root');

function componentName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function withPortal(WrappedComponent) {
  return class extends PureComponent {
    static displayName = `withPortal(${componentName(WrappedComponent)})`;

    root = document.createElement('div');

    componentDidMount() {
      portalRoot().appendChild(this.root);
    }

    componentWillUnmount() {
      portalRoot().removeChild(this.root);
    }

    render() {
      return ReactDOM.createPortal(
        <WrappedComponent {...this.props} />,
        this.root
      );
    }
  };
}
